(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('aidecounter', {
      restrict: 'E',
      bindings: {
        consultid: '<'
      },
      template: `
        <span class="badge" ng-bind="vm.counter"></span>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Patdocs', 'Rlog', 'vertxEventBusService', '$http',
        function ($log, Patdocs, Rlog, vertxEventBusService, $http) {
          let vm = this;
          const getCounter = function () {
            let query = [
              {
                $match: {
                  consultid: vm.consultid,
                  type: 'aide',
                  active: true
                }
              },
              {
                $group: {
                  _id: 'aidecounter',
                  counter: {$sum: 1}
                }
              }
            ];

            $http.post('/routes/patdocs/aggregate', query).then(res => {
              vm.counter = 0;
              if (res.data.counter) {
                vm.counter = res.data.counter;
              }
            }, err => {
              $log.error(err);
              Rlog.error('patdocs', 'refcounter', 'refcounter.$aggregate failed', {});
            });
          };


          // vm.consultid might be late propagating, get consult on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue)) {
                vm.consultid = changes.consultid.currentValue;
                getCounter();
              }
            }
          };




          // listen for patdocs updates
          vertxEventBusService.on('patdocs.update', {}, getCounter);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patdocs.update', {}, getCounter);
          };


        }
      ] // controller
    }); // component

// klammerfriedhof
}());